import builder from '../builder';
import DisabilityWheelchair1 from '../../streamline-icons/bold/disability-wheelchair-1.svg';

export default builder('IconDisabilityWheelchair1Bold', DisabilityWheelchair1);
